var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCountryLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#country-logo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f3f6f9",
  d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fb2727",
  d: "M7.652 8H16a8 8 0 0 0-.275-2.087H7.652zm0-4.174h7.174a8 8 0 0 0-1.846-2.087H7.652zM8 16c1.883 0 3.613-.65 4.98-1.74H3.02A7.97 7.97 0 0 0 8 16m-6.826-3.826h13.652a8 8 0 0 0 .898-2.087H.276c.2.744.505 1.445.898 2.087"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0073fd",
  d: "M3.706 1.25h.729l-.679.492.26.797-.679-.493-.678.493.224-.689a8 8 0 0 0-1.552 1.73h.234l-.432.313a8 8 0 0 0-.193.342l.206.635-.385-.28q-.143.305-.261.621l.227.7h.838l-.678.492.259.797-.678-.493-.406.295Q0 7.492 0 8h8V0C6.42 0 4.946.458 3.706 1.25m.31 5.95-.679-.493-.678.493.26-.797-.679-.493h.838l.26-.797.258.797h.839l-.679.493zm-.26-3.128.26.798-.679-.493-.678.493.26-.798-.679-.492h.838l.26-.797.258.797h.839zM6.885 7.2l-.678-.493-.678.493.259-.797-.678-.493h.838l.259-.797.259.797h.838l-.678.493zm-.259-3.128.259.798-.678-.493-.678.493.259-.798-.678-.492h.838l.259-.797.259.797h.838zm0-2.33.259.797-.678-.493-.678.493.259-.797-.678-.493h.838l.259-.797.259.797h.838z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "country-logo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgCountryLogo;